import React from "react";
import { BRAND } from "@/constants/brand";

export const WhatsAppButton = () => {
  const url = `https://wa.me/${BRAND.phoneDigits}?text=${encodeURIComponent(
    BRAND.whatsappMessage
  )}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-floating-button"
      aria-label="Chat on WhatsApp"
      className="ifx-whatsapp fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe5d] text-white pl-4 pr-5 py-3.5 rounded-full shadow-xl transition-all"
    >
      {/* WhatsApp glyph (no emoji) */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className="h-6 w-6 fill-current"
        aria-hidden="true"
      >
        <path d="M19.11 17.27c-.27-.13-1.6-.79-1.85-.88-.25-.09-.43-.13-.61.13-.18.27-.7.88-.86 1.06-.16.18-.32.2-.59.07-.27-.13-1.14-.42-2.17-1.34-.8-.71-1.34-1.59-1.5-1.86-.16-.27-.02-.41.12-.54.12-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.04-.34-.02-.48-.07-.13-.61-1.47-.83-2.01-.22-.53-.45-.46-.61-.47l-.52-.01c-.18 0-.48.07-.73.34-.25.27-.96.94-.96 2.29 0 1.35.99 2.66 1.13 2.84.14.18 1.95 2.98 4.73 4.18.66.28 1.18.45 1.58.58.66.21 1.27.18 1.74.11.53-.08 1.6-.65 1.83-1.27.23-.62.23-1.15.16-1.27-.07-.11-.25-.18-.52-.31zM12 .5C5.65.5.5 5.65.5 12c0 2.04.54 4.04 1.56 5.81L.5 23.5l5.83-1.53A11.5 11.5 0 0 0 12 23.5C18.35 23.5 23.5 18.35 23.5 12S18.35.5 12 .5zm0 21c-1.85 0-3.66-.5-5.24-1.43l-.38-.22-3.46.91.93-3.38-.25-.39A9.5 9.5 0 1 1 21.5 12c0 5.24-4.26 9.5-9.5 9.5z" />
      </svg>
      <span className="hidden sm:inline text-sm font-semibold tracking-wide">
        Chat on WhatsApp
      </span>
    </a>
  );
};
